import styled from 'styled-components';
import { position, space, color, layout, fontSize, flex, order, alignSelf, textAlign, background, flexbox } from 'styled-system';

function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  box-sizing: border-box;\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
var Box = styled.div(_templateObject(), position, space, color, layout, fontSize, flex, order, alignSelf, textAlign, background);
Box.displayName = "Box";
var Flex = styled(Box)(_templateObject1(), flexbox, function(param) {
    var gap = param.gap;
    return Boolean(gap) && "gap: ".concat(gap, ";");
});
Flex.displayName = "Flex";

export { Box, Flex };
